import GeneralForm from './../Forms/GeneralForm';
import MetaColumn from './MetaColumn';
import FormInputText from './../Partials/FormInputText';
import FormInputTextArea from './../Partials/FormInputTextArea';
import FormInputUpload from '../Partials/FormInputUpload';

const WorkWithUsPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "header",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "header");
                            },
                            required: true,
                            label: "سرتیتر"
                        }
                    }
                },
                {
                    field: "top_banner",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "top_banner");
                            },
                            required: true,
                            label: "بنر بالا",
                            direction: "ltr",
                            preview_style : {width: '700px', height: '300px', margin: '10px'}
                        }
                    }
                },
                {
                    field: "top_content",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "top_content");
                            },
                            required: true,
                            label: "محتوی بالا"
                        }
                    }
                },
                {
                    field: "bottom_banner",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "bottom_banner");
                            },
                            required: true,
                            label: "بنر پایین",
                            direction: "ltr",
                            preview_style : {width: '700px', height: '300px', margin: '10px'}
                        }
                    }
                },
                {
                    field: "bottom_content",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "bottom_content");
                            },
                            required: true,
                            label: "محتوی پایین"
                        }
                    }
                },
                {
                    field: "tags",
                    //build list of text
                    partial: {
                        handler: (props)=> {
                            return props.formHandler.buildArrayInputs("contents", "tags", "تگ ها")
                        },
                    }
                },
            ]
        }
    }
};

export default WorkWithUsPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/WorkWithUsPageBuilder.js